$(document).ready(function(){
  //   $(".action_button.contact_migrate").on('click', function(e){
  //   	debugger;
  //   });


  $("#contact_form").on("submit", function(e){
    
    
    if(e.originalEvent){
      e.preventDefault();
      e.stopPropagation();
      $(e.currentTarget).find("input[type=submit]").attr("disabled","disabled");
      $(e.currentTarget).find("input[type=submit]").val("Please Wait!");
      let firstName = $(this).find("#contactFormName").val();
      let email = $(this).find("#contactFormEmail").val();
      let message = $(this).find("#contactFormMessage").val();

      $("input[aria-label=Name]").val(firstName);

      $("input[aria-label=Message]").val(message);
      $(".klaviyo-form-Xqj2xK input[aria-label=Email]").val(email);

      //$("input[aria-label=Name]").closest("form").submit();

      let event = new Event("click");
      let elem = $("input[aria-label=Name]").parents("form").find("button")[0];
      let elem1 = $("input[aria-label=Name]")[0];
      let elem2 = $("input[aria-label=Message]")[0];
      let elem3 = $("input[aria-label=Email]")[0];



      let eventChange = new Event("input");
      elem1.dispatchEvent(eventChange);
      elem2.dispatchEvent(eventChange);
      elem3.dispatchEvent(eventChange);

      //     debugger;




      elem.dispatchEvent(event);




      setTimeout(function(){


        //$(".klaviyo-form-Xqj2xK").show();
        setTimeout(function(){

          $("#contact_form").submit();
        }, 100);

      }, 1500);

      
      
      
//       let params = {
//         name: firstName,
//         email: email,
//         message: message,
//         url : location.host
//       };
      
      
//       $.ajax(
//         {
//           "type" : "POST",
//           "url" :  "https://vapestore-app.herokuapp.com/",
//           "data" : params,
//           success: function (data) {
//             $(".klaviyo-form-Xqj2xK").show();
//             setTimeout(function(){




//               $("#contact_form").submit();

//             }, 3000);
//           },
//           error: function (textStatus, errorThrown) {
            
//             $(".klaviyo-form-Xqj2xK").show();
//             //Success = false;

//             setTimeout(function(){




//               $("#contact_form").submit();

//             }, 3000);
            
            
//           }
        	
//         }
//       );
      
      
      
     


    }

  });
});